import i18n from '@/plugins/i18n';
const metricsMYGraphs = () => ({
  lineCharts: [
    {
      width: '48%',
      header: {
        title: i18n.global.t('dbm.innoDBbufferPoolPagesData'),
        content: [],
        HideCenterMiscContent: true,
      },
      chartColor: ['#1fb4ff'],
      height: '12.5em',
      entityType: 'ServiceInstance',
      independentSelector: false,
      metricType: 'REGULAR_VALUE',
      metricName: 'meter_db_innodb_buffer_pool_pages_data',
      queryMetricType: 'readMetricsValues',
      childQueries: [],
      chartType: 'ApexChartLine',
      axisLabels: {
        x: i18n.global.t('dbm.time'),
        y: i18n.global.t('dbm.numberOfPages'),
      },
      showLegendForSeries: true,
    },
    {
      width: '48%',
      header: {
        title: i18n.global.t('dbm.innoDBbufferPoolPagesFree'),
        content: [],
        HideCenterMiscContent: true,
      },
      chartColor: ['#a8bbf8'],
      height: '12.5em',
      entityType: 'ServiceInstance',
      independentSelector: false,
      metricType: 'REGULAR_VALUE',
      metricName: 'meter_db_innodb_buffer_pool_pages_free',
      queryMetricType: 'readMetricsValues',
      childQueries: [],
      chartType: 'ApexChartLine',
      axisLabels: {
        x: i18n.global.t('dbm.time'),
        y: i18n.global.t('dbm.numberOfPages'),
      },
      showLegendForSeries: true,
    },
    {
      width: '48%',
      header: {
        title: i18n.global.t('dbm.innoDBRowLockCurrentWaits'),
        content: [],
        HideCenterMiscContent: true,
      },
      chartColor: ['#db9dfb'],
      height: '12.5em',
      entityType: 'ServiceInstance',
      independentSelector: false,
      metricType: 'REGULAR_VALUE',
      metricName: 'meter_db_innodb_row_lock_current_waits',
      queryMetricType: 'readMetricsValues',
      childQueries: [],
      chartType: 'ApexChartLine',
      axisLabels: {
        x: i18n.global.t('dbm.time'),
        y: i18n.global.t('dbm.count'),
      },
      showLegendForSeries: true,
    },
    {
      width: '48%',
      header: {
        title: i18n.global.t('dbm.innoDBRowLockTimeAverage'),
        content: [],
        HideCenterMiscContent: true,
      },
      chartColor: ['#f2daff'],
      height: '12.5em',
      entityType: 'ServiceInstance',
      independentSelector: false,
      metricType: 'REGULAR_VALUE',
      metricName: 'meter_db_innodb_row_lock_time_avg',
      queryMetricType: 'readMetricsValues',
      childQueries: [],
      chartType: 'ApexChartLine',
      axisLabels: {
        x: i18n.global.t('dbm.time'),
        y: 'ms',
      },
      showLegendForSeries: true,
    },
    {
      width: '48%',
      header: {
        title: i18n.global.t('dbm.innoDBRowLockWaitsPerSecond'),
        content: [],
        HideCenterMiscContent: true,
      },
      chartColor: ['#f2daff'],
      height: '12.5em',
      entityType: 'ServiceInstance',
      independentSelector: false,
      metricType: 'REGULAR_VALUE',
      metricName: 'meter_db_innodb_row_lock_waits_per_second',
      queryMetricType: 'readMetricsValues',
      childQueries: [],
      chartType: 'ApexChartLine',
      axisLabels: {
        x: i18n.global.t('dbm.time'),
        y: i18n.global.t('dbm.count'),
      },
      showLegendForSeries: true,
    },
    {
      width: '48%',
      header: {
        title: i18n.global.t('dbm.innoDBRowLockWaits'),
        content: [],
        HideCenterMiscContent: true,
      },
      chartColor: ['#f2daff'],
      height: '12.5em',
      entityType: 'ServiceInstance',
      independentSelector: false,
      metricType: 'REGULAR_VALUE',
      metricName: 'meter_db_innodb_row_lock_waits',
      queryMetricType: 'readMetricsValues',
      childQueries: [],
      chartType: 'ApexChartLine',
      axisLabels: {
        x: i18n.global.t('dbm.time'),
        y: i18n.global.t('dbm.count'),
      },
      showLegendForSeries: true,
    },
    {
      width: '48%',
      header: {
        title: i18n.global.t('dbm.totalOpenFiles'),
        content: [],
        HideCenterMiscContent: true,
      },
      chartColor: ['#abc0ff'],
      height: '12.5em',
      entityType: 'ServiceInstance',
      independentSelector: false,
      metricType: 'REGULAR_VALUE',
      metricName: 'meter_db_open_files',
      queryMetricType: 'readMetricsValues',
      childQueries: [],
      chartType: 'ApexChartLine',
      axisLabels: {
        x: i18n.global.t('dbm.time'),
        y: i18n.global.t('dbm.numberOfFiles'),
      },
      showLegendForSeries: true,
    },
    {
      width: '48%',
      header: {
        title: i18n.global.t('dbm.totalOpenTables'),
        content: [],
        HideCenterMiscContent: true,
      },
      chartColor: ['#2f67ff'],
      height: '12.5em',
      entityType: 'ServiceInstance',
      independentSelector: false,
      metricType: 'REGULAR_VALUE',
      metricName: 'meter_db_open_tables',
      queryMetricType: 'readMetricsValues',
      childQueries: [],
      chartType: 'ApexChartLine',
      axisLabels: {
        x: i18n.global.t('dbm.time'),
        y: i18n.global.t('dbm.numberOfTables'),
      },
      showLegendForSeries: true,
    },
    {
      width: '48%',
      header: {
        title: i18n.global.t('dbm.maxUsedConnections'),
        content: [],
        HideCenterMiscContent: true,
      },
      chartColor: ['#8fde87'],
      height: '12.5em',
      entityType: 'ServiceInstance',
      independentSelector: false,
      metricType: 'REGULAR_VALUE',
      metricName: 'meter_net_max_used_connections',
      queryMetricType: 'readMetricsValues',
      childQueries: [],
      chartType: 'ApexChartLine',
      axisLabels: {
        x: i18n.global.t('dbm.time'),
        y: i18n.global.t('dbm.numberOfConnections'),
      },
      showLegendForSeries: true,
    },
    {
      width: '48%',
      header: {
        title: i18n.global.t('dbm.NetConnectionErrorsPerSecond'),
        content: [],
        HideCenterMiscContent: true,
      },
      chartColor: ['#8fde87'],
      height: '12.5em',
      entityType: 'ServiceInstance',
      independentSelector: false,
      metricType: 'REGULAR_VALUE',
      metricName: 'meter_net_connection_errors_max_connections_per_second',
      queryMetricType: 'readMetricsValues',
      childQueries: [],
      chartType: 'ApexChartLine',
      axisLabels: {
        x: i18n.global.t('dbm.time'),
        y: i18n.global.t('dbm.numberOfConnectionsPerSecond'),
      },
      showLegendForSeries: true,
    },
    {
      width: '48%',
      header: {
        title: i18n.global.t('dbm.NetConnectionErrors'),
        content: [],
        HideCenterMiscContent: true,
      },
      chartColor: ['#8fde87'],
      height: '12.5em',
      entityType: 'ServiceInstance',
      independentSelector: false,
      metricType: 'REGULAR_VALUE',
      metricName: 'meter_net_connection_errors_max_connections',
      queryMetricType: 'readMetricsValues',
      childQueries: [],
      chartType: 'ApexChartLine',
      axisLabels: {
        x: i18n.global.t('dbm.time'),
        y: i18n.global.t('dbm.numberOfConnections'),
      },
      showLegendForSeries: true,
    },
    {
      width: '48%',
      header: {
        title: i18n.global.t('dbm.selectQueries'),
        content: [],
        HideCenterMiscContent: true,
      },
      chartColor: ['#8fde87'],
      height: '12.5em',
      entityType: 'ServiceInstance',
      independentSelector: false,
      metricType: 'REGULAR_VALUE',
      metricName: 'meter_query_com_select',
      queryMetricType: 'readMetricsValues',
      childQueries: [],
      chartType: 'ApexChartLine',
      axisLabels: {
        x: i18n.global.t('dbm.time'),
        y: i18n.global.t('dbm.queries'),
      },
      showLegendForSeries: true,
    },
    {
      width: '48%',
      header: {
        title: i18n.global.t('dbm.insertQueries'),
        content: [],
        HideCenterMiscContent: true,
      },
      chartColor: ['#8fde87'],
      height: '12.5em',
      entityType: 'ServiceInstance',
      independentSelector: false,
      metricType: 'REGULAR_VALUE',
      metricName: 'meter_query_com_insert',
      queryMetricType: 'readMetricsValues',
      childQueries: [],
      chartType: 'ApexChartLine',
      axisLabels: {
        x: i18n.global.t('dbm.time'),
        y: i18n.global.t('dbm.queries'),
      },
      showLegendForSeries: true,
    },
    {
      width: '48%',
      header: {
        title: i18n.global.t('dbm.selectQueriesPerSecond'),
        content: [],
        HideCenterMiscContent: true,
      },
      chartColor: ['#8fde87'],
      height: '12.5em',
      entityType: 'ServiceInstance',
      independentSelector: false,
      metricType: 'REGULAR_VALUE',
      metricName: 'meter_query_com_select_per_second',
      queryMetricType: 'readMetricsValues',
      childQueries: [],
      chartType: 'ApexChartLine',
      axisLabels: {
        x: i18n.global.t('dbm.time'),
        y: i18n.global.t('dbm.queriesPerSecondCount'),
      },
      showLegendForSeries: true,
    },
    {
      width: '48%',
      header: {
        title: i18n.global.t('dbm.insertQueriesPerSecond'),
        content: [],
        HideCenterMiscContent: true,
      },
      chartColor: ['#8fde87'],
      height: '12.5em',
      entityType: 'ServiceInstance',
      independentSelector: false,
      metricType: 'REGULAR_VALUE',
      metricName: 'meter_query_com_insert_per_second',
      queryMetricType: 'readMetricsValues',
      childQueries: [],
      chartType: 'ApexChartLine',
      axisLabels: {
        x: i18n.global.t('dbm.time'),
        y: i18n.global.t('dbm.queriesPerSecondCount'),
      },
      showLegendForSeries: true,
    },
    {
      width: '48%',
      header: {
        title: i18n.global.t('dbm.slowQueriesPerSecond'),
        content: [],
        HideCenterMiscContent: true,
      },
      chartColor: ['#8fde87'],
      height: '12.5em',
      entityType: 'ServiceInstance',
      independentSelector: false,
      metricType: 'REGULAR_VALUE',
      metricName: 'meter_query_slow_queries_per_second',
      queryMetricType: 'readMetricsValues',
      childQueries: [],
      chartType: 'ApexChartLine',
      axisLabels: {
        x: i18n.global.t('dbm.time'),
        y: i18n.global.t('dbm.queriesPerSecondCount'),
      },
      showLegendForSeries: true,
    },
    {
      width: '48%',
      header: {
        title: i18n.global.t('dbm.slowQueriesCount'),
        content: [],
        HideCenterMiscContent: true,
      },
      chartColor: ['#8fde87'],
      height: '12.5em',
      entityType: 'ServiceInstance',
      independentSelector: false,
      metricType: 'REGULAR_VALUE',
      metricName: 'meter_query_slow_queries',
      queryMetricType: 'readMetricsValues',
      childQueries: [],
      chartType: 'ApexChartLine',
      axisLabels: {
        x: i18n.global.t('dbm.time'),
        y: i18n.global.t('dbm.queries'),
      },
      showLegendForSeries: true,
    },
    {
      width: '48%',
      header: {
        title: i18n.global.t('dbm.queriesCount'),
        content: [],
        HideCenterMiscContent: true,
      },
      chartColor: ['#8fde87'],
      height: '12.5em',
      entityType: 'ServiceInstance',
      independentSelector: false,
      metricType: 'REGULAR_VALUE',
      metricName: 'meter_query_queries',
      queryMetricType: 'readMetricsValues',
      childQueries: [],
      chartType: 'ApexChartLine',
      axisLabels: {
        x: i18n.global.t('dbm.time'),
        y: i18n.global.t('dbm.queries'),
      },
      showLegendForSeries: true,
    },
    {
      width: '48%',
      header: {
        title: i18n.global.t('dbm.queriesPerSecond'),
        content: [],
        HideCenterMiscContent: true,
      },
      chartColor: ['#8fde87'],
      height: '12.5em',
      entityType: 'ServiceInstance',
      independentSelector: false,
      metricType: 'REGULAR_VALUE',
      metricName: 'meter_query_queries_per_second',
      queryMetricType: 'readMetricsValues',
      childQueries: [],
      chartType: 'ApexChartLine',
      axisLabels: {
        x: i18n.global.t('dbm.time'),
        y: i18n.global.t('dbm.queriesPerSecondCount'),
      },
      showLegendForSeries: true,
    },
    {
      width: '48%',
      header: {
        title: i18n.global.t('dbm.deadlockCount'),
        content: [],
        HideCenterMiscContent: true,
      },
      chartColor: [],
      height: '12.5em',
      entityType: 'ServiceInstance',
      independentSelector: false,
      metricType: 'REGULAR_VALUE',
      metricName: 'meter_deadlock_count',
      queryMetricType: 'readMetricsValues',
      childQueries: ['#7f678c'],
      chartType: 'ApexChartLine',
      axisLabels: {
        x: i18n.global.t('dbm.time'),
        y: i18n.global.t('dbm.count'),
      },
      showLegendForSeries: true,
    },
    {
      width: '48%',
      header: {
        title: i18n.global.t('dbm.preparedStatementsPerSecond'),
        content: [],
        HideCenterMiscContent: true,
      },
      chartColor: [],
      height: '12.5em',
      entityType: 'ServiceInstance',
      independentSelector: false,
      metricType: 'REGULAR_VALUE',
      metricName: 'meter_query_prepared_stmt_count_per_second',
      queryMetricType: 'readMetricsValues',
      childQueries: ['#7f678c'],
      chartType: 'ApexChartLine',
      axisLabels: {
        x: i18n.global.t('dbm.time'),
        y: i18n.global.t('dbm.countPerSecond'),
      },
      showLegendForSeries: true,
    },
    {
      width: '48%',
      header: {
        title: i18n.global.t('dbm.preparedStatements'),
        content: [],
        HideCenterMiscContent: true,
      },
      chartColor: [],
      height: '12.5em',
      entityType: 'ServiceInstance',
      independentSelector: false,
      metricType: 'REGULAR_VALUE',
      metricName: 'meter_query_prepared_stmt_count',
      queryMetricType: 'readMetricsValues',
      childQueries: ['#7f678c'],
      chartType: 'ApexChartLine',
      axisLabels: {
        x: i18n.global.t('dbm.time'),
        y: i18n.global.t('dbm.count'),
      },
      showLegendForSeries: true,
    },
  ],
});

export default metricsMYGraphs;
